export type DateOnlyString = `${number}-${string}-${string}`;

/** Converts a Date to a DateOnly string of format YYYY-MM-DD */
export function toDateOnlyString(source: Date | null | undefined): DateOnlyString | null {
    if (!source || isNaN(source.getTime())) {
        return null;
    }

    const year = source.getFullYear();
    const month = String(source.getMonth() + 1).padStart(2, '0');
    const day = String(source.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

/** Creates a Date from a DateOnly string of format YYYY-MM-DD  */
export function fromDateOnlyString(dateOnly: string | null | undefined): Date | null {
    if (!dateOnly || !isDateOnlyString(dateOnly)) {
        return null;
    }

    const [year, month, day] = dateOnly.split('-').map(Number);

    if (!year || !month || !day) {
        return null;
    }

    return new Date(year, month - 1, day);
}

/** True if the provided string is the DateOnly format of YYYY-MM-DD */
export function isDateOnlyString(dateOnly: unknown): dateOnly is DateOnlyString {
    return typeof dateOnly === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateOnly);
}